import { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useModal } from "../../../../../../../utils/hook/useModal"
import { SchedulesExportFRM103ResType } from "../../../../models/list/export"

export const useVariablesExportFile = () => {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const [formId, setFormId] = useState("")
  const [messageConfirmDownload, setMessageConfirmDownload] = useState("")
  const [isOpenModalExport, setIsOpenModalExport] = useState(false)
  const [dataSourceFrm103, setDataSourceFrm103] = useState<
    SchedulesExportFRM103ResType[]
  >([])

  const {
    isOpen: isOpenExportFrm103OverRecord,
    onCancel: onCancelExportFrm103OverRecord,
    onOpen: onOpenExportFrm103OverRecord,
  } = useModal()

  return {
    dataSourceFrm103,
    formId,
    isOpenExportFrm103OverRecord,
    isOpenModalExport,
    messageConfirmDownload,
    onCancelExportFrm103OverRecord,
    onOpenExportFrm103OverRecord,
    pathname,
    push,
    setDataSourceFrm103,
    setFormId,
    setIsOpenModalExport,
    setMessageConfirmDownload,
  }
}
